import React, { FC } from 'react';
import Layout from '../Common/NewLayout';
import Header from '../Common/NewLayout/Header';
import ExplanationText from './ExplanationText';
import { Box } from '@material-ui/core';
import { CustomButton } from '../Ui/CustomButton';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import {
  CreatePaymentStripe,
  CreatePaymentStripeVariables,
} from '../../graphql/onboarding/stripe/types/CreatePaymentStripe';
import { CREATE_PAYMENT_STRIPE } from '../../graphql/onboarding/stripe/mutation';
import { useToastNotifications } from '../../utils/toastUtils';

const ExplanationProvider: FC = () => {
  const navigate = useNavigate();
  const { showErrorToast } = useToastNotifications();

  const [createPayment, { loading: stripeLoading }] = useMutation<
    CreatePaymentStripe,
    CreatePaymentStripeVariables
  >(CREATE_PAYMENT_STRIPE, {
    onCompleted: (url) => {
      if (url.createPaymentStripe) {
        navigate('/explanation', { replace: true });
        window.location.replace(url.createPaymentStripe);
      }
    },
    onError: (error) => {
      showErrorToast({
        description: `Impossible de charger la page de paiement de création du société. Veuillez réessayer plus tard ou contacter le support technique si le problème persiste.
`,
      });
    },
  });
  const handlePrevious = () => {
    navigate('/package', { replace: true });
  };

  const handleNext = () => {
    const cancelUrl = window.location.href;
    const successUrl = cancelUrl.replace('explanation', 'legalplace');
    createPayment({
      variables: {
        cancelUrl,
        successUrl,
        isPackage: true,
      },
    });
  };
  return (
    <Layout description="Vous êtes à deux pas de lancer votre entreprise ! ">
      <Header
        title="Plus que quelques clics pour créer votre entreprise"
        description="Un parcours de création simple et rapide"
      />
      <ExplanationText />
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '1rem',
        }}
      >
        <CustomButton
          type="button"
          variant="outline4"
          onClick={handlePrevious}
          label="button.previous"
          fullWidthMobile
          disabled={stripeLoading}
        />
        <CustomButton
          type="button"
          variant="primary"
          onClick={handleNext}
          label="button.next"
          fullWidthMobile
          loading={stripeLoading}
        />
      </Box>
    </Layout>
  );
};

export default ExplanationProvider;
